import * as React from "react";
function SvgIcJoint(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.575 6L5 7.333 9.324 12 5 16.667 5.575 18l5.03-5.428h6.39l-3.22 4.393 1.193.543 4.032-5.5-4.032-5.499-1.192.543 3.219 4.393H10.62L5.575 6z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcJoint;
